import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  icon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  icon = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 text-base font-medium transition-all duration-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-slate-900 text-white hover:bg-slate-800 focus:ring-slate-900 shadow-sm hover:shadow-md',
    secondary: 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-600 shadow-sm',
    outline: 'border-2 border-slate-200 text-slate-700 hover:border-slate-900 hover:text-slate-900 bg-transparent'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-153">
      {children}
      {icon && <ArrowRight className="ml-2 h-4 w-4" data-id="element-154" />}
    </button>;
}